/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */
import {
  DEFAULT_ENTITY,
  LOADER_STATUS,
  PROFILE_DATA,
  SET_ENTITY_LIST,
  SET_FILING_STATUS,
  STORE_ENTITY,
  STORE_GSTIN,
  STORE_GSTIN_GSTR1NEW,
  STORE_PERIOD,
  STORE_PERIOD_SINGLE,
  VENDOR_LIST,
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  // entityList:[],
  selectedEntity: "",
  selectedGstin: [],
  selectedPeriodSingle: null,
  // selectedPeriodSingle:'',
  filingStatus: "",
  entityMasterList: [],
  defaultEntity: "",
  startDate: null,
  endDate: null,
};

/* eslint-disable default-case, no-param-reassign */
const gstr1NewCommonReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case STORE_PERIOD:
      return {
        ...state,
        startDate: action.date.startDate,
        endDate: action.date.endDate,
      };
    case STORE_PERIOD_SINGLE:
      return {
        ...state,
        selectedPeriodSingle: action.date,
      };
    // case STORE_ENTITY:
    //   return {
    //     ...state,
    //     selectedEntity:action.selectedEntity
    //   }
    // case STORE_GSTIN:
    //   return {
    //     ...state,
    //     selectedGstin:action.selectedGstin
    //   }
    // case STORE_PERIOD:
    //   return {
    //     ...state,
    //     selectedPeriod:action.selectedPeriod
    //   }
    case SET_ENTITY_LIST:
      return {
        ...state,
        entityMasterList: action.payload,
      };
    case DEFAULT_ENTITY:
      return {
        ...state,
        defaultEntity: action.data,
      };
    case STORE_GSTIN_GSTR1NEW:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    // case SET_FILING_STATUS:
    //   return {
    //     ...state,
    //     filingStatus:action.filingStatus
    //   }
    // case VENDOR_LIST:
    //   return {
    //     ...state,
    //     vendorList:action.vendorList
    //   }
    default:
      return state;
  }
};

export default gstr1NewCommonReducer;
